import {IApplicationState} from '../../../../../../types/types';
import {ENavigationPanelTypes} from '../../constants';
import {getNavigationPanelState} from './getNavigationPanelState';

export const navigationPanelTypeSelector = (
    state: IApplicationState
): ENavigationPanelTypes => {
    return getNavigationPanelState(state).panelType;
};
